var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("rect",{"x":"24","width":"2","height":"24","transform":"rotate(90 24 0)","fill":"currentColor"}));
}

Minus.defaultProps = {"width":"24","height":"2","viewBox":"0 0 24 2","fill":"none"};

module.exports = Minus;

Minus.default = Minus;
